<template>
  <div
    class="home"
    ref="home"
    v-loading="loadingMap"
    v-infinite-scroll="loadMore"
    infinite-scroll-immediate="false"
    infinite-scroll-distance="80"
    infinite-scroll-delay="100"
  >
    <div class="head">
      <div class="head_top">
        <img src="../assets/title.png" alt="" />
        <div class="head_title">
          <span class="huo_icon"></span>
          <span class="zhekou">本周限时星巴克8折！</span>
        </div>
      </div>
      <div class="head_bot">
        <div @click="toCity" class="cityEjectBtn">
          <span class="cityIco"></span>
          <span class="cityName">{{ cityName }}</span>
        </div>
        <div class="searchCon">
          <input
            @focus="historyShow"
            @blur="hideHistory"
            type="text"
            placeholder="盖浇牛柳鸡排"
            v-model="searchCon"
            @keydown="toProductFilter2(searchCon, $event)"
          />
          <!-- <div @click="toProductFilter2(searchCon)" class="searchBtn">搜索</div> -->
          <div v-if="historyIsShow" class="searchHistory">
            <div class="shTit">搜索历史</div>
            <ul class="shList">
              <li
                @click="toProductFilter3(item)"
                v-for="(item, index) in searchHistory"
                :key="index"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div v-if="recommendList.length > 0" class="banner">
        <yd-slider autoplay="116000">
          <yd-slider-item
            class="eachBanner"
            v-for="(item, index) in bannerList"
            :key="index"
          >
            <a :href="item.productUrl"><img :src="item.faceImg"/></a>
          </yd-slider-item>
        </yd-slider>
      </div>
    </div>

    <!-- <div class="banner">
			<yd-slider autoplay="3000">
				<yd-slider-item>
					<img src="../assets/banner3.jpg">
		
				</yd-slider-item>
				<yd-slider-item>
					<img src="../assets/banner2.jpg">
						
				</yd-slider-item>
				<yd-slider-item>
					<img src="../assets/banner.jpg">
						
				</yd-slider-item>
			</yd-slider>
		</div> -->

    <ul class="classifyList clearfix">
      <li @click="toProductFilter(0)" class="eachClassify fl">
        <img src="../assets/classify_1.png" alt="" />
      </li>
      <li @click="toProductFilter(1)" class="eachClassify fl">
        <img src="../assets/classify_2.png" alt="" />
      </li>
      <li @click="toProductFilter(2)" class="eachClassify fl">
        <img src="../assets/classify_3.png" alt="" />
      </li>
      <li @click="toProductFilter(4)" class="eachClassify fl">
        <img src="../assets/classify_4.png" alt="" />
      </li>
      <li @click="toProductFilter(3)" class="eachClassify fl">
        <img src="../assets/classify_5.png" alt="" />
      </li>
      <li class="eachClassify fl">
        <a :href="xingBaKeUrl"><img src="../assets/classify_6.png" alt=""/></a>
      </li>
      <li class="eachClassify fl">
        <a :href="kendejiUrl"><img src="../assets/classify_7.png" alt=""/></a>
      </li>
      <li class="eachClassify fl">
        <a :href="dianYingPiaoUrl"
          ><img src="../assets/classify_8.png" alt=""
        /></a>
      </li>
      <li class="eachClassify fl">
        <a
          href="https://weiq.tongli3d.com/app/index.php?i=9&c=entry&do=index&partner_id=27&m=hc_recharge#/pages/index/recharge/recharge?hcid=30&wxref=mp.weixin.qq.com#/wechat_redirect"
          ><img src="../assets/classify_9.png" alt=""
        /></a>
      </li>
      <li class="eachClassify fl">
        <a
          href="https://weiq.tongli3d.com/app/index.php?i=9&c=entry&do=index&partner_id=27&m=hc_recharge#/pages/index/recharge/recharge?hcid=64&wxref=mp.weixin.qq.com#/wechat_redirect"
          ><img src="../assets/classify_10.png" alt=""
        /></a>
      </li>
      <li class="eachClassify fl">
        <a
          href="https://weiq.tongli3d.com/app/index.php?i=9&c=entry&do=index&partner_id=27&m=hc_recharge#/pages/index/recharge/recharge?hcid=78&wxref=mp.weixin.qq.com#/wechat_redirect"
          ><img src="../assets/classify_11.png" alt=""
        /></a>
      </li>
      <li class="eachClassify fl">
        <a
          href="https://weiq.tongli3d.com/app/index.php?i=9&c=entry&do=index&partner_id=27&m=hc_recharge#/pages/index/index?hcid=78&wxref=mp.weixin.qq.com#/wechat_redirect"
          ><img src="../assets/classify_12.png" alt=""
        /></a>
      </li>
    </ul>

    <!-- 爆款推荐 -->
    <div class="recommend">
      <div class="recommendHead">
        <span class="tit1"><span>周边活动</span></span>
        <!-- <span class="tit2">（爆款推荐，分享赚钱）</span> -->

        <!-- <div class="filterBtn">
					<span @click="filterType = true">一</span>
					<span @click="filterType = false">二</span>
				</div> -->
      </div>

      <ul v-if="hasProduct" class="recommendList">
        <li
          @click="
            toShopList(item.bizId, item.faceImg, item.productUrl, item.type)
          "
          v-for="(item, index) in recommendList"
          :key="index"
          class="clearfix"
        >
          <div class="recommendPic"><img :src="item.faceImg" alt="" /></div>
          <div class="recommendMes">
            <div class="recommendTit">{{ item.description }}</div>
            <div class="recommendName">
              <span>{{ item.title }}</span>
              <div v-if="item.kilometers > 1" class="distance">
                {{ item.kilometers.toFixed(1) }}km
              </div>
              <div v-else class="distance">
                {{ (item.kilometers * 1000).toFixed(0) }}m
              </div>
            </div>

            <div class="price">
              <span>￥</span>{{ item.salePrice / 100 }}
              <span
                style="text-decoration: line-through;color: #999999;font-size: 0.24rem;"
                >门市价：￥{{ item.originPrice / 100 }}</span
              >
            </div>
            <div class="buyBtn">立即购买</div>
          </div>
        </li>
      </ul>

      <div v-else class="noProduct">
        暂无活动
      </div>
    </div>

    <div v-show="showTips" class="tipsIco">
      <div class="tipsAddress">
        <span class="cityIco"></span>
        <span class="cityName">{{ cityName }}</span>
      </div>
      <img class="tipPic" src="../assets/sqzsIco6.png" alt="" />
      <img class="know" @click="hideTips()" src="../assets/iknow.png" alt="" />
    </div>

    <div v-if="needShow" class="loadingWhite"></div>

    <div v-show="!loadingMap" v-if="isRouterAlive">
      <FootTab></FootTab>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import FootTab from "@/components/FootTab.vue";
// import Head from "@/components/Head.vue";
import { Slider, SliderItem } from "vue-ydui/dist/lib.rem/slider";
Vue.component(Slider.name, Slider);
Vue.component(SliderItem.name, SliderItem);
export default {
  name: "home",
  components: {
    FootTab,
  },
  data() {
    return {
      bannerArr: [],

      cityName: "",
      searchCon: "",

      classifyArr: [],

      defaultImg: require("../assets/headBg.png"),

      recommendList: [],
      page: 1,
      loading: true,

      code: "",

      loadingMap: false,

      scroll: 200,
      searchHistory: [],
      historyIsShow: false,

      kendejiUrl: "",
      dianYingPiaoUrl: "",
      xingBaKeUrl: "",

      hasProduct: true,

      filterType: true,

      bannerList: [],

      showTips: false,

      isRouterAlive: true,

      isiOS: true,

      needShow: true,
      imgUrlList: [
        "../assets/classify_1.png",
        "../assets/classify_2.png",
        "../assets/classify_3.png",
        "../assets/classify_4.png",
        "../assets/classify_5.png",
      ],
    };
  },
  activated() {
    this.$router.options.routes[1].meta.keepAlive = true;
    this.$refs.home.scrollTop = this.scroll;
  },
  created() {
    var that = this;
    that.http
      .isExpire({
        phone: localStorage.getItem("phone"),
      })
      .then((res) => {
        console.log(res.data);
        // if(!res.data.data){
        // 	 this.$alert("您为非会员，将为您跳转到订购页", "", {
        //   confirmButtonText: "确定",
        //   showClose: false,
        //   callback: (action) => {
        //     location.href = "https://www.baidu.com";
        //   },
        // });
        // }
      });
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) {
      if (sessionStorage.getItem("needShow") != "false") {
        sessionStorage.setItem("needShow", "false");
        setTimeout(function() {
          window.location.reload();
        }, 20);
      } else {
        that.needShow = false;
      }
    } else {
      that.needShow = false;
    }

    // 获取渠道信息
    that.http
      .getActivity({
        sourceType: localStorage.getItem("sourceType"),
      })
      .then((res) => {
        console.log(res.data);
        that.kendejiUrl = res.data.data[1].activityUrl;
        that.dianYingPiaoUrl = res.data.data[2].activityUrl;
        that.xingBaKeUrl = res.data.data[3].activityUrl;
        localStorage.setItem("meiTuanUrl", res.data.data[0].activityUrl);
      });
  },
  mounted() {
    var that = this;

    // setTimeout(function () {
    // 	that.reload();
    // },1200)

    if (localStorage.getItem("locationType") != 2) {
      that.getLocation();
    } else {
      that.cityName = localStorage.getItem("LocationCity");
      that.getProduct();

      setTimeout(function() {
        if (localStorage.getItem("isFirstTips") != "false") {
          that.showTips = true;
        }
      }, 2000);
      // that.showTips = true;
    }

    // 获取美食餐饮等菜单
    that.http.getBizMenuList({}).then((res) => {
      console.log("获取美食餐饮等菜单-====", res.data.data);
      that.classifyArr = res.data.data.slice(0, 5);
    });

    // 获取banner
    that.http
      .getQueryProduct({
        lat: "",
        lon: "",
        limit: 5,
        page: 1,
        isBook: "",
        menuId: "",
        menuLevel: "",
        sourceType: localStorage.getItem("sourceType"),
        areaName: localStorage.getItem("areaName") || "",
      })
      .then((res) => {
        console.log(res.data);
        that.bannerList = res.data.data;
      });
  },
  methods: {
    defImg() {
      // 图片加载失败时加载占位图
      let img = event.srcElement;
      img.src = this.defaultImg;
      img.onerror = null; //防止闪图
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
    hideTips() {
      this.showTips = false;
      localStorage.setItem("isFirstTips", "false");
    },
    toCity() {
      this.$router.push({ name: "city" });
    },
    historyShow() {
      this.searchHistory =
        eval("(" + localStorage.getItem("searchHistory") + ")") || [];
      if (this.searchHistory.length == 0) {
        this.historyIsShow = false;
      } else {
        this.historyIsShow = true;
      }
    },
    hideHistory() {
      var that = this;
      setTimeout(function() {
        that.historyIsShow = false;
      }, 100);
    },
    toProductFilter2(searchText, e) {
      console.log("seaaaa", e.keyCode);
      if (e.keyCode == 13) {
        this.searchHistory.unshift(searchText);
        if (this.searchHistory.length > 7) {
          this.searchHistory.splice(7);
        }

        localStorage.setItem(
          "searchHistory",
          JSON.stringify(this.searchHistory)
        );
        this.$router.push({
          path: "/productFilter",
          query: {
            typeName: searchText,
            hasHead: "false",
            menuNum: -1,
            description: searchText,
            noBook: "true",
          },
        });
      }
    },
    toProductFilter3(searchText) {
      this.$router.push({
        path: "/productFilter",
        query: {
          typeName: searchText,
          hasHead: "false",
          menuNum: -1,
          description: searchText,
          noBook: "true",
        },
      });
    },
    getProduct() {
      //获取活动
      // var that = this;
      // that.http.getProduct({
      // 	"typeName": '',
      // 	"page": that.page,
      // 	"sourceType":localStorage.getItem("sourceType")
      // }).then((res) => {
      // 	console.log(res.data);
      // 	if (res.data.data.length < 10) {
      // 		that.loading = false;
      // 		that.recommendList.push(...res.data.data);
      // 	} else {
      // 		that.recommendList.push(...res.data.data);
      // 	}
      // })

      var that = this;

      that.http
        .getQueryProduct({
          lat: localStorage.getItem("locationLat"),
          lon: localStorage.getItem("locationLon"),
          limit: 10,
          page: that.page,
          isBook: "",
          menuId: "",
          menuLevel: "",
          sourceType: localStorage.getItem("sourceType"),
          areaName: localStorage.getItem("areaName") || "",
        })
        .then((res) => {
          console.log(res.data);
          if (res.data.count == "0" && that.page < 2) {
            that.hasProduct = false;
            this.$alert("未能获取定位，自助精准定位查询", "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                that.$router.push({ name: "city" });
              },
            });
          }

          if (res.data.data.length < 10) {
            that.loading = false;
            that.recommendList.push(...res.data.data);
          } else {
            that.recommendList.push(...res.data.data);
          }
        });
    },
    loadMore() {
      var that = this;
      if (that.loading == false) {
        return;
      }
      that.page = that.page + 1;
      that.getProduct("");
    },
    toProductFilter(menuNum) {
      localStorage.setItem("selectValue", "");
      localStorage.setItem("menuNum", menuNum);
      this.$router.push({
        path: "/productFilter",
        query: {
          hasHead: "true",
          noBook: "true",
        },
      });
    },
    toShopList(bizId, shopPic, shopLink, type) {
      sessionStorage.setItem("shopPic", shopPic);
      sessionStorage.setItem("shopLink", shopLink);
      window.location.href = shopLink;
      // this.$router.push({
      // 	path: '/shopList',
      // 	query: {
      // 		bizId: bizId,
      // 		type:type,
      // 		productType:1
      // 	}
      // })
    },
    getLocation() {
      //获取坐标
      console.log(11111);
      const that = this;
      that.loadingMap = true;
      AMap.plugin("AMap.Geolocation", function() {
        var geolocation = new AMap.Geolocation({
          // 是否使用高精度定位，默认：true
          enableHighAccuracy: true,
          // 设置定位超时时间，默认：无穷大
          timeout: 10000,
        });

        geolocation.getCurrentPosition();
        AMap.event.addListener(geolocation, "complete", onComplete);
        AMap.event.addListener(geolocation, "error", onError);

        function onComplete(data) {
          // data是具体的定位信息
          console.log("定位成功信息：", data);
          localStorage.setItem("areaName", data.addressComponent.city);
          localStorage.setItem(
            "LocationCity",
            data.addressComponent.district + data.addressComponent.street
          );
          localStorage.setItem("locationLat", data.position.lat);
          localStorage.setItem("locationLon", data.position.lng);

          localStorage.setItem("locationType", 2);
          that.loadingMap = false;
          that.cityName =
            data.addressComponent.district + data.addressComponent.street;
          that.getProduct("");
        }

        function onError(data) {
          // 定位出错
          console.log("定位失败错误：", data);
          // 调用ip定位
          that.getLngLatLocation();
        }
      });
    },
    getLngLatLocation() {
      var that = this;
      AMap.plugin("AMap.CitySearch", function() {
        var citySearch = new AMap.CitySearch();
        citySearch.getLocalCity(function(status, result) {
          if (status === "complete" && result.info === "OK") {
            // 查询成功，result即为当前所在城市信息
            console.log("通过ip获取当前城市：", result);
            localStorage.setItem("areaName", result.city);
            // localStorage.setItem("LocationCity", result.district + result.street);
            localStorage.setItem(
              "locationLat",
              result.rectangle.split(";")[1].split(",")[1]
            );
            localStorage.setItem(
              "locationLon",
              result.rectangle.split(";")[1].split(",")[0]
            );
            localStorage.setItem("locationType", 2);
            that.loadingMap = false;

            that.getProduct("");

            //逆向地理编码
            AMap.plugin("AMap.Geocoder", function() {
              var geocoder = new AMap.Geocoder({
                // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                city: result.adcode,
              });

              var lnglat = result.rectangle.split(";")[0].split(",");
              geocoder.getAddress(lnglat, function(status, data) {
                if (status === "complete" && data.info === "OK") {
                  // result为对应的地理位置详细信息
                  console.log(data);
                  localStorage.setItem(
                    "LocationCity",
                    data.regeocode.addressComponent.district +
                      (data.regeocode.addressComponent.township || "")
                  );
                  that.cityName =
                    data.regeocode.addressComponent.district +
                    (data.regeocode.addressComponent.township || "");
                }
              });
            });
          }
        });
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.scroll = this.$refs.home.scrollTop;
    next(); //一定不要忘记写
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name == "city") {
        window.location.reload();
      }
      vm.$router.options.routes[1].meta.keepAlive = true;
      vm.searchCon = "";
    }); //一定不要忘记写
  },
};
</script>

<style scoped lang="scss">
.home {
  height: 100vh;
  overflow: auto;
  padding-bottom: 0.9rem;
  background-color: #f5f5f5;

  .head {
    // height: 4.26rem;
    padding: 0.18rem 0.17rem 0rem 0.17rem;
    background-image: url(../assets/bannerBg.png);
    background-size: 7.52rem 3.4rem;
    background-repeat: no-repeat;
    .head_top {
      margin: 0.3rem 0;
      display: flex;
      justify-content: start;
      & > img {
        width: 1.55rem;
        height: 0.3rem;
      }
      .head_title {
        margin: 0.05rem 0 0 0.2rem;
        .huo_icon {
          display: inline-block;
          width: 0.19rem;
          height: 0.23rem;
          background-image: url("../assets/huo.png");
          background-size: 100% 100%;
        }
        .zhekou {
          display: inline-block;
          font-size: 0.2rem;
          -webkit-transform: translateX(-0.15rem) scale(0.8333);
        }
      }
    }
    .head_bot {
      margin-top: 0.1rem;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-right: 0.2rem;
    }
    .cityEjectBtn {
      box-sizing: border-box;
      background-color: #fcdb58;
      display: flex;
      justify-content: start;
      font-size: 0.24rem;
      text-align: left;
      position: relative;
      // top: .1rem;
      width: 1.91rem;
      height: 0.61rem;
      border-radius: 0.3rem;

      padding: 0.01rem 0.15rem;
      line-height: 0.61rem;

      .cityName {
        display: inline-block;
        vertical-align: middle;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        // max-width: 1.5rem;
      }

      .cityIco {
        display: inline-block;
        vertical-align: middle;
        width: 0.23rem;
        height: 0.25rem;
        background-image: url(../assets/sqzsDingWeiIco.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        top: 0.15rem;
        margin-right: 0.1rem;
      }
    }

    .searchCon::before {
      content: "";
      position: absolute;
      width: 0.27rem;
      height: 0.29rem;
      background-image: url(../assets/sqzsIco3.png);
      background-size: cover;
      background-repeat: no-repeat;
      top: 50%;
      left: 0.25rem;
      transform: translateY(-50%);
    }
    .searchCon {
      // margin-top: 0.28rem;
      width: 5.06rem;
      height: 0.64rem;
      position: relative;

      input {
        &::-webkit-search-cancel-button {
          display: none;
        }
        display: block;
        width: 100%;
        height: 100%;
        background-color: #f5f5f5;
        text-indent: 0.3rem;
        border-radius: 100px;
        font-size: 0.24rem;
        text-indent: 0.66rem;
      }

      .searchBtn {
        width: 1.05rem;
        height: 0.55rem;
        line-height: 0.55rem;
        position: absolute;
        right: 0.05rem;
        top: 50%;
        transform: translateY(-50%);
        background-color: #ee7036;
        border-radius: 100px;
        font-size: 0.29rem;
        color: #ffffff;
      }

      .searchHistory {
        position: absolute;
        top: calc(100% + 0.1rem);
        width: 100%;
        background-color: #fff;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
        padding: 0.3rem 0.2rem;
        border-radius: 0.06rem;
        text-align: left;
        z-index: 100;
        position: absolute;

        .shTit {
          font-size: 0.28rem;
          color: #999999;
          padding-top: 0.1rem;
        }

        .shList {
          position: relative;
          margin-top: 0.3rem;

          li {
            padding: 0.15rem 0rem;
            color: #333333;
            font-size: 0.26rem;
          }
        }
      }
    }

    .banner {
      width: 100%;
      margin-top: 0.16rem;
      border-radius: 0.12rem;
      height: 1.96rem;
      overflow: hidden;

      .yd-slider {
        height: 100%;

        .eachBanner {
          position: relative;

          img {
            position: absolute;
            height: auto;
            width: 100%;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
          }
        }
      }
    }
  }

  .classifyList {
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    width: 94%;
    margin: 0.3rem auto 0px;
    border-radius: 0.04rem;

    .eachClassify {
      width: 25%;
      margin-bottom: 0.29rem;

      img {
        // width: 1.2rem;
        // height: 1.25rem;
        margin: 0px auto;
      }
      &:nth-child(1) img {
        width: 1.2rem;
        height: 1.25rem;
      }
      &:nth-child(2) img {
        width: 1.23rem;
        height: 1.22rem;
      }
      &:nth-child(3) img {
        width: 1.18rem;
        height: 1.25rem;
      }
      &:nth-child(4) img {
        width: 1.15rem;
        height: 1.21rem;
      }
      &:nth-child(5) img {
        width: 0.97rem;
        height: 1.12rem;
      }
      &:nth-child(6) img {
        width: 1.03rem;
        height: 1.25rem;
      }
      &:nth-child(7) img {
        width: 0.96rem;
        height: 1.2rem;
      }
      &:nth-child(8) img {
        width: 1.2rem;
        height: 1.11rem;
      }
      &:nth-child(9) img {
        width: 0.86rem;
        height: 1.06rem;
      }
      &:nth-child(10) img {
        width: 0.95rem;
        height: 1.05rem;
      }
      &:nth-child(11) img {
        width: 0.78rem;
        height: 1.05rem;
      }
      &:nth-child(12) img {
        width: 0.82rem;
        height: 1.05rem;
      }
    }
  }

  .recommend {
    margin-top: 0.28rem;
    padding: 0px 0.24rem;

    .recommendHead {
      text-align: left;
      position: relative;

      .tit1 {
        font-size: 0.38rem;
        line-height: 0.38rem;
        color: #2f2f2f;
        font-weight: bold;
        position: relative;

        span {
          z-index: 2;
          position: relative;
        }
      }
      .tit1::before {
        content: "";
        position: absolute;
        right: -0.1rem;
        bottom: 0rem;
        width: 0.28rem;
        height: 0.28rem;
        background-color: #f7ddb1;
        z-index: 1;
        border-radius: 100px;
      }

      .tit2 {
        font-size: 0.24rem;
        color: rgba(47, 47, 47, 0.6);
      }

      .filterBtn {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 2.06rem;
        height: 0.58rem;
        background-color: #efefef;
        border-radius: 100px;
        line-height: 0.58rem;
        text-align: center;

        span {
          display: inline-block;
          vertical-align: middle;
          width: 0.88rem;
          height: 0.46rem;
          line-height: 0.46rem;
          background-color: #fff;
          border-radius: 100px;
          margin: 0px 0.04rem;
        }
      }
    }

    .recommendList {
      margin-top: 0.3rem;
      text-align: left;

      li {
        // padding: 0.22rem 0.27rem 0.22rem 0.24rem;
        background-color: #fff;
        border-radius: 0.14rem;
        margin-bottom: 0.26rem;
        box-shadow: 0px 0px 0.24rem rgb(0 0 0 / 7%);

        .recommendPic {
          width: 100%;
          height: 3.3rem;
          // background-color: #afafaf;
          border-top-left-radius: 0.14rem;
          border-top-right-radius: 0.14rem;
          overflow: hidden;
          position: relative;

          img {
            position: absolute;
            height: auto;
            width: 100%;
            min-height: 3.2rem;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
          }
          img.active {
            height: 100%;
          }
        }

        .recommendMes {
          width: 100%;
          position: relative;
          padding: 0.2rem 0.2rem 0.8rem;

          .recommendTit {
            font-size: 0.28rem;
            font-weight: bold;
            color: #1c1c1c;
            line-height: 0.38rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box; // 作为弹性伸缩盒子模型显示。
            -webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式--从上到下垂直排列
            -webkit-line-clamp: 3; // 显示的行
            text-align: justify;
          }

          .recommendName {
            color: rgba(28, 28, 28, 0.6);
            font-size: 0.24rem;
            margin-top: 0.14rem;
            position: relative;
            display: -webkit-box; // 作为弹性伸缩盒子模型显示。
            -webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式--从上到下垂直排列
            -webkit-line-clamp: 1; // 显示的行
            text-align: justify;
            line-height: 0.32rem;
            padding-right: 1.3rem;
            overflow: hidden;

            .distance {
              position: absolute;
              right: 0;
              top: 0;
              height: 0.2rem;
              color: rgba(28, 28, 28, 0.6);
            }
          }

          .price {
            position: absolute;
            font-size: 0.36rem;
            color: #f73030;
            font-weight: bold;
            left: 0.2rem;
            bottom: 0.2rem;
          }

          .buyBtn {
            position: absolute;
            bottom: 0.2rem;
            right: 0.2rem;
            width: 1.24rem;
            height: 0.4rem;
            line-height: 0.4rem;
            background-image: linear-gradient(270deg, #ff5b23 0%, #fb8d17 100%),
              linear-gradient(#e2373d, #e2373d);
            border-radius: 100px;
            text-align: center;
            color: #fff;
            font-size: 0.24rem;
          }
        }
      }
    }

    .noProduct {
      text-align: center;
      font-size: 0.36rem;
      color: #999999;
      font-weight: bold;
      padding-top: 2rem;
      letter-spacing: 0.06rem;
    }
  }

  .tipsIco {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10000;
    background-color: rgba(0, 0, 0, 0.7);
    padding-top: 0.2rem;
    text-align: left;

    .tipPic {
      position: absolute;
      top: 1.9rem;
      left: 1.64rem;
      width: 3.75rem;
      height: 3.01rem;
    }
    .know {
      position: absolute;
      top: 5.3rem;
      left: 2rem;
      width: 2.2rem;
      height: 0.64rem;
    }

    .tipsAddress {
      display: inline-block;
      font-size: 0.32rem;
      color: #ffffff;
      line-height: 0.38rem;
      text-align: left;
      border: 1px dotted #ffffff;
      margin-left: 0.2rem;
      padding: 0.08rem 0.12rem;
      border-radius: 0.18rem;
      background-color: #fcdb58;
      margin-top: 0.9rem;
      .cityName {
        color: #000;
        font-size: 0.24rem;
        display: inline-block;
        vertical-align: middle;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        // max-width: 1.5rem;
      }

      .cityIco {
        display: inline-block;
        vertical-align: middle;
        width: 0.23rem;
        height: 0.25rem;
        background-image: url(../assets/sqzsDingWeiIco.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin-right: 0.18rem;
      }
    }
  }

  .loadingWhite {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999999999999999999;
    background-color: rgba(255, 255, 255, 1);
  }
}
</style>
